let categorySelector = document.getElementById("categoryselect")
let tagSelectors = document.querySelectorAll(".tagselect")
let sortOrderSelector = document.getElementById("sort-order-select")

if (categorySelector) {
    categorySelector.addEventListener("change", async function (event) {
        beginSearch()
    })
}
if (tagSelectors) {
    tagSelectors.forEach(function (tagSelector, idx) {
        tagSelector.addEventListener('change', function () {
            beginSearch(tagSelector.value)
        });
    });
}
if (sortOrderSelector) {
    sortOrderSelector.addEventListener("change", async function (event) {
        let tagSelectorValue = document.getElementsByClassName('selectedTag')[0]?.value;
        beginSearch(tagSelectorValue)
    })
}

async function beginSearch(tagSelectorValue) {
    optionsList = []
    inclusiveExtrasList = []

    let url = document.getElementById('filter-form').action
    let currentUrl = document.getElementById('current-path-input').value;
    selectedCategory = categorySelector?.value ?? null
    selectedTag = tagSelectorValue ?? null
    selectedSortOrder = sortOrderSelector?.value ?? null
    let data = await getTreatments(url, selectedCategory, selectedTag, selectedSortOrder, currentUrl)
    renderHTML(data)
}

async function getTreatments(url, category, tag, sortOrder, currentUrl) {
    const URL = url
    const payload = {
        category: category,
        tag: tag,
        sortOrder: sortOrder,
        currentUrl: currentUrl
    }
    let output = await axios.post(URL, payload).then(
        response => {
            return response.data
        },
        error => { },
    )
    return output
}

function renderHTML(html) { 
    let treatmentsContainer = document.getElementById('treatments-container');
    if (html) {
        treatmentsContainer.innerHTML = html;
    }
    else {
        treatmentsContainer.innerHTML = '<div class="flex w-full justify-center text-center"><div>Sorry, no treatments found with these search parameters. <br> Please adjust your search.</div></div>';
    }
    
}
